import { Observable } from 'rxjs';

/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MoneyPot } from '@api/models/money-pot.entity';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

@Injectable()
export class MoneyPotService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public find(name: string): Observable<MoneyPot[]> {
		return this.http.get<MoneyPot[]>(
			`${this.config.apiUrl}/api/v2/private/money-pot/${name}`,
		);
	}
}
